const sortProjects = projects =>
  [...(projects || [])].sort((a, b) => {
    const aPrimaryDate = a?.project_start || a?.created_at || '';
    const bPrimaryDate = b?.project_start || b?.created_at || '';
    if (aPrimaryDate !== bPrimaryDate) {
      return bPrimaryDate.localeCompare(aPrimaryDate);
    }
    const aCreatedAt = a?.created_at || '';
    const bCreatedAt = b?.created_at || '';
    if (aCreatedAt !== bCreatedAt) {
      return bCreatedAt.localeCompare(aCreatedAt);
    }
    return `${a?.name || ''}`.localeCompare(`${b?.name || ''}`);
  });

export default {
  researchNotesState(state) {
    return state.notes;
  },
  researchNotesMetaState(state) {
    return state.notesMeta;
  },
  researchNotesFilterOptionsByScopeState(state) {
    return state.notesFilterOptionsByScope || {};
  },
  researchNotesAssetsByScopeState(state) {
    return state.notesAssetsByScope || {};
  },
  researchNotesAssetsLoadingByScopeState(state) {
    return state.notesAssetsLoadingByScope || {};
  },
  researchNotesAssetsErrorByScopeState(state) {
    return state.notesAssetsErrorByScope || {};
  },
  researchResearcherClientsState(state) {
    return state.researcherClients || [];
  },
  researchSharepointFilesByClientState(state) {
    return state.sharepointFilesByClient || {};
  },
  researchSharepointFilesLoadingByClientState(state) {
    return state.sharepointFilesLoadingByClient || {};
  },
  researchSharepointFilesErrorByClientState(state) {
    return state.sharepointFilesErrorByClient || {};
  },
  researchArchiveFilesByClientState(state) {
    return state.archiveFilesByClient || {};
  },
  researchArchiveFilesLoadingByClientState(state) {
    return state.archiveFilesLoadingByClient || {};
  },
  researchArchiveFilesErrorByClientState(state) {
    return state.archiveFilesErrorByClient || {};
  },
  researchProjectsByClientState(state) {
    return state.projectsByClient || {};
  },
  researchProjectsLoadingByClientState(state) {
    return state.projectsLoadingByClient || {};
  },
  researchProjectsErrorByClientState(state) {
    return state.projectsErrorByClient || {};
  },
  researchSkillSessionsByClientState(state) {
    return state.skillSessionsByClient || {};
  },
  researchSkillSessionsLoadingByClientState(state) {
    return state.skillSessionsLoadingByClient || {};
  },
  researchSkillSessionsErrorByClientState(state) {
    return state.skillSessionsErrorByClient || {};
  },
  researchDisplayedProjectsState(state, getters) {
    const selectedClientReference = getters.researchSavedClientsState?.selectedClientReference || {};

    if (!selectedClientReference?.client && !selectedClientReference?.member) {
      return [];
    }

    if (selectedClientReference?.client) {
      return sortProjects(state.projectsByClient?.[`${selectedClientReference.client}`]?.objects || []);
    }

    return [];
  },
  researchMembersUpdatingState(state) {
    return state.researchMembersUpdating;
  },
  researchNotesLoadingState(state) {
    return state.notesLoading;
  },
  researchNoteState(state) {
    return state.note || {};
  },
  researchNoteLoadingState(state) {
    return state.noteLoading;
  },
  researchNoteUpdateLoadingState(state) {
    return state.noteUpdateLoading;
  },
  researchUnifiedSearchListState(state) {
    return state.unifiedSearchList || [];
  },
  researchUnifiedSearchMetaState(state) {
    return state.unifiedSearchMeta || {};
  },
  researchUnifiedSearchLoadingState(state) {
    return state.unifiedSearchLoading;
  },
  researchSavedClientsState(state) {
    return state.savedClients || {};
  },
};
